import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiModule } from './ui/ui.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { ScrollspyDirective } from './scrollspy.directive';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';



@NgModule({
  declarations: [
    SpinnerComponent,
    ScrollspyDirective,
    TopbarComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    UiModule
  ],
  exports:[
    SpinnerComponent,
    ScrollspyDirective,
    TopbarComponent,
    FooterComponent
  ]
})
export class SharedModule { }
